module.exports = __webpack_public_path__ + "static/media/3DPPA20.9b81167c.jpg";